import { AspectRatioBox, Stack, Text } from '@moda/om';
import React from 'react';
import { RequestReturnPrintableLabel } from '../RequestReturnPrintableLabel';
import { Image } from '../../Image';
import { useReturnInProgressItems } from './useReturnInProgressItems';

import './RequestReturnInProgressItems.scss';

export const RequestReturnInProgressItems = () => {
  const returnInProgressItems = useReturnInProgressItems();

  if (returnInProgressItems.length === 0) return null;

  return (
    <Stack space={4}>
      <Text treatment="h5">Items Requested for Return</Text>

      <Stack className="RequestReturnInProgressItems__items" direction="horizontal" space={2}>
        {returnInProgressItems.map(item => (
          <Stack key={item.id} space={2} alignItems="center">
            <AspectRatioBox maxHeight={270} maxWidth={170}>
              <Image src={item.attributes.images.medium} />
            </AspectRatioBox>

            <RequestReturnPrintableLabel item={item} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
